import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
interface CaseStudyHeroProps {
  image: string;
  mobileImage?: string;
}
export function CaseStudyHero({
  image,
  mobileImage
}: CaseStudyHeroProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  return <div ref={ref} className="relative h-[90vh] min-h-[600px] w-full overflow-hidden bg-slate-900 text-white" data-id="element-28">
      {/* Background Image with Parallax */}
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 z-0" data-id="element-29">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white/40 z-10" data-id="element-30" />

        {/* Mobile Image */}
        {mobileImage && <img src={mobileImage} alt="Case Study Hero" className="h-full w-full object-cover object-top md:hidden" data-id="element-31" />}

        {/* Desktop Image */}
        <img src={image} alt="Case Study Hero" className={`h-full w-full object-cover object-right ${mobileImage ? 'hidden md:block' : ''}`} data-id="element-32" />
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 z-20" data-id="element-33">
        <ArrowDown className="animate-bounce h-6 w-6" data-id="element-34" />
      </motion.div>
    </div>;
}